<template>
  <div class="selector">
    <div class="selector-headers">
      <li :class="{
        'selector-selected-item':selectedHeader===item
      }" v-for="(item, index) in headers" :key="index" class="selector-header-item" @click="onHeaderClick(item)">
        {{item}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li :class="{
        'selector-selected-item':itemIn(item)
      }" v-for="(item, index) in items" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.text}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li :class="{
        'selector-selected-item':itemIn(item)
      }" v-for="(item, index) in all" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.text}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="select-form">
      <div  class="form-horizontal">
        <flaw-form :flaw="flaw"></flaw-form>
        <div class="form-group">
          <div class="col-sm-10 col-sm-offset-2">
            <button class="btn btn-default" @click="addFlaw">添加</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as TYPES from '../../store/types'
import _ from 'lodash'
import FlawForm from '../forms/Flaw'

export default {
  components: {
    FlawForm
  },
  data() {
    return {
      flaw: {}
    }
  },
  computed: {
    headers() {
      return this.$store.state.flaws.selector.headers
    },
    items() {
      return this.$store.state.flaws.selector.items
    },
    all() {
      return this.$store.state.flaws.all
    },
    selectedHeader() {
      return this.$store.state.flaws.selector.selectedHeader
    },
    selectedItems() {
      return this.$store.state.flaws.selector.selectedItems
    }
  },
  created() {
    this.$store.dispatch(TYPES.DO_GET_FLAWS_SELECTOR_HEADERS)
    this.$store.dispatch(TYPES.DO_GET_ALL_FLAWS)
  },
  methods: {
    itemIn(item) {
      return _.indexOf(this.selectedItems, item) > -1
    },
    onHeaderClick(item) {
      this.$store
        .dispatch(TYPES.DO_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER, item)
    },
    onSelected(item) {
      if (_.indexOf(this.selectedItems, item) > -1) {
        console.log('delete', item)
        _.pull(this.selectedItems, item)
        this.selectedItems = Object.assign([], this.selectedItems)
      } else {
        this.selectedItems.push(item)
      }
      this.$emit('onSelected', this.selectedItems)
    },
    addFlaw() {
      this.$store.dispatch(TYPES.DO_ADD_FLAW, this.flaw)
      .then(res => {
        this.$notify({
          type: 'success',
          content: '成功添加瑕疵'
        })
        this.onHeaderClick(this.selectedHeader)
      })
      .catch(res => {
        console.log(res)
        this.$notify({
          type: 'danger',
          content: res.data.msg
        })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/selectors/Flaw.vue